import { useState, useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { main } from "utils";
const useDarkTheme = JSON.parse(localStorage.getItem("darkTheme"));
export const themed = {
  style: {
    borderRadius: "0",
    background: useDarkTheme ? "#1f1f1f" : "#fff",
    color: useDarkTheme ? "#fff" : "#000",
    border: useDarkTheme ? "" : `0.5px solid ${main[100]}`,
    boxShadow: "0 2px 4px rgb(0 0 0 / 8%), 0 4px 12px rgb(0 0 0 / 8%)",
  },
};
export function ToastAlert() {
  const [position, setPosition] = useState("bottom-right");
  useEffect(() => {
    setPosition(window.innerWidth > 800 ? "bottom-right" : "bottom-center");
  }, []);
  return <Toaster position={position} reverseOrder={false} />;
}
